import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { OverlayGroupsState } from '@/redux/overlayGroup/overlayGroup.types';
import { getOverlayGroup, getOverlayGroups } from '@/redux/overlayGroup/overlayGroup.thunks';
import { OverlayGroup } from '@/types/models';
import { ONE } from '@/constants/common';

export const getOverlayGroupsReducer = (
  builder: ActionReducerMapBuilder<OverlayGroupsState>,
): void => {
  builder.addCase(getOverlayGroups.pending, state => {
    state.loading = 'pending';
  });
  builder.addCase(getOverlayGroups.fulfilled, (state, action) => {
    state.data = action.payload || undefined;
    state.loading = 'succeeded';
  });
  builder.addCase(getOverlayGroups.rejected, state => {
    state.loading = 'failed';
    // TODO to discuss manage state of failure
  });
};

export const getOverlayGroupReducer = (
  builder: ActionReducerMapBuilder<OverlayGroupsState>,
): void => {
  builder.addCase(getOverlayGroup.fulfilled, (state, action) => {
    if (!action.payload) {
      return;
    }
    const group: OverlayGroup = action.payload;
    const { id } = group;
    if (state.data) {
      let found = false;
      for (let i = 0; i < state.data.length; i += ONE) {
        if (state.data[i].id === id) {
          found = true;
          state.data[i] = group;
        }
      }
      if (!found) {
        state.data.push(group);
      }
    } else {
      state.data = [group];
    }
  });
};

export const deleteOverlayGroupReducer = (
  state: OverlayGroupsState,
  action: PayloadAction<{ groupId: number }>,
): void => {
  const { groupId } = action.payload;
  if (!state.data) {
    return;
  }

  const groupIndex = state.data.findIndex(group => group.id === groupId);
  if (groupIndex > -ONE) {
    state.data.splice(groupIndex, ONE);
  }
};
